export default __webpack_public_path__ + "static/media/smiley1-open.86dedba7.svg";